module.exports = __webpack_public_path__ + "static/img/layer7.d009b4a9.png";